import * as React from 'react'
import { useState, useEffect } from 'react'

import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useTranslation } from "react-i18next"
import { Tooltip } from '@mui/material'
import TablePagination from "@mui/material/TablePagination"
import { t } from 'i18next'
import { visuallyHidden } from '@mui/utils'
import dayjs from 'dayjs'
import { useAuth } from '../../hooks/auth'

import { getComparator, stableSort } from '../../helpers/DailyBoardTableHelpers'
import CreateSalesOrderCustomerUser from '../sales_purchase_orders/CreateSalesOrderCustomerUser'
import RejectSalesOrder from '../sales_purchase_orders/RejectSalesOrder'
import { useStateContext } from '../../context/ContextProvider'
import CreateBrokerTransactionCustomerUser from '../broker/CreateBrokerTransactionCustomerUser'
import MoveSite from '../sales_purchase_orders/MoveSite'

function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false)

    return (
        <React.Fragment >
            <TableRow sx={{ '& > *': { borderBottom: 'unset !important' } }}>
                <TableCell sx={{ padding: '8px 16px' }}>{<ShowDate date={row.requested_shipment_date} />}</TableCell>
                {!localStorage.getItem('client_id').includes('pallet-book') && (
                    <TableCell sx={{ padding: '8px 16px' }}>{<ShowDate date={row.requested_shipment_date} />}</TableCell>
                )}
                <TableCell sx={{ padding: '8px 16px', fontStyle: 'italic' }}>{row.customer_name}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>{row.ship_to_location_name}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>{row.customer_po_no}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>{row.comments}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>{row?.site_name}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    {
                        <TodaysSalesOrderAction order={row} />
                    }
                </TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell style={{ padding: 0 }} colSpan={9}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: '20%' }}>{t('item_no')}</TableCell>
                                        <TableCell sx={{ width: '50%' }}>{t('description')}</TableCell>
                                        <TableCell sx={{ width: '10%' }}>{t('quantity_ordered')}</TableCell>
                                        <TableCell sx={{ width: '10%' }}>{t('qty_shipped')}</TableCell>
                                        <TableCell sx={{ width: '10%' }}>{t('qty_delivered')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.sales_order_items.map((historyRow) => (
                                        <TableRow key={historyRow.id}>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.item_no}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.description}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_ordered}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_to_ship}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_shipped}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>

        </React.Fragment>
    );
}

const SortableTableHeaderRow = (props) => {
    const { order, orderBy, onRequestSort } = props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {/* Requested Delivery Date cell */}
                <TableCell
                    sortDirection={orderBy === 'requested_shipment_date' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'requested_shipment_date'}
                        direction={orderBy === 'requested_shipment_date' ? order : 'asc'}
                        onClick={createSortHandler('requested_shipment_date')}>
                        {t('requested_delivery_date')}
                        {orderBy === 'requested_shipment_date' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>

                {/* Shipped Date cell */}
                {!localStorage.getItem('client_id').includes('pallet-book') && (
                    <TableCell
                        sortDirection={orderBy === 'shipment_date' ? order : false}>
                        <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                            active={orderBy === 'shipment_date'}
                            direction={orderBy === 'shipment_date' ? order : 'asc'}
                            onClick={createSortHandler('shipment_date')}>
                            {t('shipment_date')}
                            {orderBy === 'shipment_date' ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                )}

                {/* customer cell */}
                <TableCell
                    sortDirection={orderBy === 'customer_name' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'customer_name'}
                        direction={orderBy === 'customer_name' ? order : 'asc'}
                        onClick={createSortHandler('customer_name')}>
                        {t('customer')}
                        {orderBy === 'customer_name' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>

                {/* ship_to_location cell */}
                <TableCell
                    sortDirection={orderBy === 'ship_to_location' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'ship_to_location'}
                        direction={orderBy === 'ship_to_location' ? order : 'asc'}
                        onClick={createSortHandler('ship_to_location')}>
                        {t('ship_to_location')}
                        {orderBy === 'ship_to_location' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>

                {/* Sales Order No. cell */}
                <TableCell
                    sortDirection={orderBy === 'customer_po_no' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'customer_po_no'}
                        direction={orderBy === 'customer_po_no' ? order : 'asc'}
                        onClick={createSortHandler('customer_po_no')}>
                        {t('customer_po_no')}
                        {orderBy === 'customer_po_no' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>

                <TableCell
                    sortDirection={orderBy === 'comments' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'comments'}
                        direction={orderBy === 'comments' ? order : 'asc'}
                        onClick={createSortHandler('comments')}>
                        {t('comments')}
                        {orderBy === 'comments' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>

                </TableCell>

                <TableCell
                    sortDirection={orderBy === 'site_name' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'site_name'}
                        direction={orderBy === 'site_name' ? order : 'asc'}
                        onClick={createSortHandler('site_name')}>
                        {t('site')}
                        {orderBy === 'site_name' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>

                <TableCell sx={{ color: '#88909C !important', fontWeight: '400' }}>{t('actions')}</TableCell>

                <TableCell />
            </TableRow>
        </TableHead>
    )
}

export default function CollapsibleTable({ items }) {

    const { t } = useTranslation()

    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(10);
    const [shipments, setShipments] = useState([])
    const [orderBy, setOrderBy] = useState('created_at')
    const [order, setOrder] = useState('desc')

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const handleRequestSort = (event, property) => {
        if (order === 'desc' && orderBy === property) {
            setOrderBy('created_at')
        } else {
            const isAsc = orderBy === property && order === 'asc'
            setOrder(isAsc ? 'desc' : 'asc')
            setOrderBy(property)
        }
    }

    const visibleShipments = React.useMemo(
        () =>
            stableSort(items, getComparator(order, orderBy)).slice(
                pg * rpg,
                pg * rpg + rpg,
            ),
        [items, order, orderBy, pg, rpg],
    )

    return (
        <>

            <div>
                <TableContainer>
                    <Table aria-label="collapsible table" stickyHeader>
                        <colgroup>
                            {!localStorage.getItem('client_id').includes('pallet-book') ? (
                                <>
                                    <col width="12.5%" />
                                    <col width="12.5%" />
                                    <col width="15%" />
                                    <col width="15%" />
                                    <col width="12.5%" />
                                    <col width="17.5%" />
                                    <col width="10%" />
                                    <col width="17.5%" />
                                    <col />
                                </>
                            ) : (
                                <>
                                    <col width="12.5%" />
                                    <col width="12.5%" />
                                    <col width="17.5%" />
                                    <col width="17.5%" />
                                    <col width="30%" />
                                    <col width="10%" />
                                    <col width="15%" />
                                    <col />
                                </>

                            )}
                        </colgroup>
                        <SortableTableHeaderRow
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            {items.length <= 0 ? <TableRow><TableCell colSpan={8} sx={{ textAlign: 'center' }}>{t('no_data')}</TableCell></TableRow> : null}
                            {visibleShipments?.map((row) => (
                                <Row key={row.id} row={row} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    className='table-pagination'
                    labelRowsPerPage={t('rowsPerPage')}
                    rowsPerPageOptions={[10, 15]}
                    component="div"
                    count={items.length}
                    rowsPerPage={rpg}
                    page={pg}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </>
    );
}

const TodaysSalesOrderAction = ({ order }) => {
    const { t } = useTranslation()

    const { user } = useAuth({ middleware: 'guest' })
    const { clientIsBrokerOnly, allSites } = useStateContext()
    const [open, setOpen] = useState(false)
    const [openSmall, setOpenSmall] = useState(false)

    const sites = allSites?.filter((site) => site.company_id == localStorage.getItem('company_id'));
    const [openMoveSite, setOpenMoveSite] = useState(false);

    const handleOpen = async () => {
        setIsLoading(true)

        /* await axios.put(`/api/shipment-requests/accept-request/${order?.id}`, config).then(({ data }) => {
            setIsLoading(false)
        }).catch(({ response }) => {
            setIsLoading(false)
        }) */

        setOpen(!open)
    }

    const handleOpenSmall = () => {
        setOpenSmall(!openSmall)
    }

    const [isLoading, setIsLoading] = useState(false)

    return (
        <>
            <div className='flex gap-2'>
                <Tooltip disableInteractive title={user?.cannot_create ? t('free_limit_exceeded') : "Accept Shipment"} placement='bottom'>
                    <span>
                        <div
                            className={`flex justify-center items-center icons p-2 ${user?.cannot_create ? 'pointer-events-none text-gray-400 rounded-full bg-gray-200' : 'text-[#8fcd92] hover:rounded-full hover:bg-zinc-200'}`}
                            onClick={handleOpen}
                        >
                            <i className="fa-solid fa-check"></i>
                        </div>
                    </span>
                </Tooltip>
                <Tooltip disableInteractive  title="Reject Shipment" placement='bottom'>
                    <div
                        className={`flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200 text-[#ff6b6b]`}
                        onClick={handleOpenSmall}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </div>
                </Tooltip>

                {(!clientIsBrokerOnly && sites.length > 1) && (
                    <Tooltip disableInteractive title={t('move_site')} placement='bottom'>
                        <div style={{ color: 'rgba(0,0,0,.54)' }}>
                            <span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200" onClick={(e) => setOpenMoveSite(true)}><i className="fa-solid fa-building-circle-arrow-right"></i></span>
                        </div>
                    </Tooltip>
                )}
            </div>
            {clientIsBrokerOnly ? (
                <CreateBrokerTransactionCustomerUser open={open} handleOpen={handleOpen} request={order} setIsLoading={setIsLoading} />
            ) : (
                <CreateSalesOrderCustomerUser open={open} handleOpen={handleOpen} order={order} setIsLoading={setIsLoading} />
            )}

            <RejectSalesOrder type={'shipment'} open={openSmall} handleOpen={handleOpenSmall} order={order} setIsLoading={setIsLoading} title={t('reject_shipment')} />

            <MoveSite
                open={openMoveSite}
                setOpen={setOpenMoveSite}
                id={order.id}
                _siteId={order.site_id}
                type="sales"
                isRequest={true}
                sites={sites}
            />
        </>
    )
}

export const ShowDate = ({ date }) => {

    const date1 = new Date(dayjs(date).format("YYYY-MM-DD"))
    const date2 = new Date(dayjs().format("YYYY-MM-DD"))

    return (
        <div>
            {
                date1 < date2 ? <p style={{ color: '#F00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                    date1 == date2 ? <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                        date1 > date2 ? <p style={{ color: '#008E00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                            <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p>
            }
        </div>
    )
}
